<template>
  <section class="videoModal">
    <div class="videoWrapper">
      <iframe
        width="560"
        height="315"
        :src="dataset.url"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope;
      picture-in-picture"
        allowfullscreen
      />
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'VideoModal',
  props: {
    title: String,
    dataset: Object
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    ...mapMutations('modal', ['hideModal'])
  }
}
</script>

<style lang="scss" scoped></style>
